import {
  MENU_ITEM_SELECTED_BG,
  menuItemStyles,
  menuListStyles,
  menuPaperStyles,
} from 'lib/styles/menu'

export const OUTLINED_INPUT_BORDER = '#C4C7C9'
export const OUTLINED_INPUT_BORDER_HOVER = '#70787C'
export const OUTLINED_INPUT_BORDER_RADIUS = 12
export const OUTLINED_INPUT_FOCUS_BORDER = '#0053FF'

export const CALLOUT_BACKGROUND = '#EBF0F2'
export const CALLOUT_FOREGROUND = '#172024'
export const PROMO_CALLOUT_BACKGROUND = '#E8EFFF'
export const PROMO_CALLOUT_BORDER = '#B8CCFF'
export const PROMO_CALLOUT_BORDER_RADIUS = 12

export const outlinedInputThemeOverrides = {
  MuiOutlinedInput: {
    root: {
      borderRadius: OUTLINED_INPUT_BORDER_RADIUS,
      '&:hover:not(.Mui-disabled):not(.Mui-error) .MuiOutlinedInput-notchedOutline': {
        borderColor: OUTLINED_INPUT_BORDER_HOVER,
      },
      '&.Mui-focused:not(.Mui-error) .MuiOutlinedInput-notchedOutline': {
        borderColor: OUTLINED_INPUT_FOCUS_BORDER,
      },
    },
    notchedOutline: {
      borderColor: OUTLINED_INPUT_BORDER,
    },
  },
  MuiInputLabel: {
    outlined: {
      fontWeight: 400,
      color: OUTLINED_INPUT_BORDER_HOVER,
      '&.Mui-focused:not(.Mui-error)': {
        color: OUTLINED_INPUT_BORDER_HOVER,
      },
    },
  },
  MuiFormHelperText: {
    root: {
      marginTop: 6,
    },
  },
}

export const getOutlinedTextFieldWrapperStyles = theme => ({
  '& .MuiInputBase-root': {
    minHeight: 40,
    borderRadius: OUTLINED_INPUT_BORDER_RADIUS,
    backgroundColor: theme.palette.common.white,
    '&:hover': {
      backgroundColor: '#F4F6F8',
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: OUTLINED_INPUT_BORDER,
    borderRadius: OUTLINED_INPUT_BORDER_RADIUS,
  },
  '& .MuiOutlinedInput-notchedOutline legend': {
    display: 'none',
  },
  '& .MuiInputBase-root:hover:not(.Mui-disabled):not(.Mui-error) .MuiOutlinedInput-notchedOutline': {
    borderColor: OUTLINED_INPUT_BORDER_HOVER,
  },
  '& .MuiInputBase-root.Mui-focused:not(.Mui-error) .MuiOutlinedInput-notchedOutline': {
    borderColor: OUTLINED_INPUT_FOCUS_BORDER,
  },
  '& .MuiOutlinedInput-input': {
    padding: '8px 12px',
    fontSize: '0.875rem',
    fontWeight: 500,
    color: CALLOUT_FOREGROUND,
    boxSizing: 'border-box',
  },
  '& .MuiFormHelperText-root': {
    marginTop: 6,
  },
})

export const getOutlinedSelectWrapperStyles = theme => ({
  '& .MuiFormControl-root': {
    width: '100%',
  },
  '& .MuiOutlinedInput-root': {
    height: 40,
    borderRadius: OUTLINED_INPUT_BORDER_RADIUS,
    backgroundColor: theme.palette.common.white,
    '&:hover:not(.Mui-disabled):not(.Mui-error) .MuiOutlinedInput-notchedOutline': {
      borderColor: OUTLINED_INPUT_BORDER_HOVER,
    },
    '&.Mui-focused:not(.Mui-error) .MuiOutlinedInput-notchedOutline': {
      borderColor: OUTLINED_INPUT_FOCUS_BORDER,
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: OUTLINED_INPUT_BORDER,
  },
  '& .MuiSelect-select': {
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 12,
    paddingRight: 32,
    fontSize: '0.875rem',
    fontWeight: 500,
    color: CALLOUT_FOREGROUND,
    display: 'flex',
    alignItems: 'center',
  },
  '& .MuiSelect-select:focus': {
    backgroundColor: 'transparent',
  },
  '& .MuiSelect-icon': {
    color: CALLOUT_FOREGROUND,
    right: 8,
  },
})

export const getOutlinedSelectMenuPaperStyles = theme => ({
  marginTop: theme.spacing(0.5),
  ...menuPaperStyles,
  backgroundColor: theme.palette.common.white,
  overflow: 'hidden',
  '& .MuiList-padding': {
    padding: menuListStyles.padding,
  },
  '& .MuiMenuItem-root': {
    ...menuItemStyles,
    fontWeight: 500,
    color: CALLOUT_FOREGROUND,
  },
  '& .MuiMenuItem-root.Mui-selected': {
    backgroundColor: MENU_ITEM_SELECTED_BG,
    color: CALLOUT_FOREGROUND,
    '&:hover': {
      backgroundColor: MENU_ITEM_SELECTED_BG,
    },
  },
})

export const outlinedPickerFieldSx = {
  width: '100%',
  '& .MuiOutlinedInput-root': {
    borderRadius: `${OUTLINED_INPUT_BORDER_RADIUS}px`,
  },
  '& .MuiOutlinedInput-input': {
    fontFamily: 'Inter, sans-serif',
    fontSize: '0.875rem',
    fontWeight: 500,
    color: CALLOUT_FOREGROUND,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: OUTLINED_INPUT_BORDER,
  },
  '& .MuiOutlinedInput-root:hover:not(.Mui-disabled):not(.Mui-error) .MuiOutlinedInput-notchedOutline': {
    borderColor: OUTLINED_INPUT_BORDER_HOVER,
  },
  '& .MuiOutlinedInput-root.Mui-focused:not(.Mui-error) .MuiOutlinedInput-notchedOutline': {
    borderColor: OUTLINED_INPUT_FOCUS_BORDER,
  },
  '& .MuiInputLabel-outlined': {
    color: OUTLINED_INPUT_BORDER_HOVER,
    fontWeight: 400,
  },
  '& .MuiInputLabel-outlined.Mui-focused:not(.Mui-error)': {
    color: OUTLINED_INPUT_BORDER_HOVER,
    fontWeight: 400,
  },
}
